import { DeviceTypeEnum, DeviceStatusEnum, DeviceCategoryEnum } from "@gtpl/shared-models/masters";
import {Column,Entity,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";


@Entity('device')
export class Device {
  @PrimaryGeneratedColumn('increment', { name: 'device_id' })
  deviceId: number;

  @Column("varchar",{
    nullable:false,
    length:20,
    name:"device_name"
  })
  deviceName:string;

  @Column({
    type: 'enum',
    enum: DeviceTypeEnum,
    nullable: false,
    default: DeviceTypeEnum.HAND_HELD,
    name: 'device_type'
  })
  deviceType: DeviceTypeEnum;

  @Column("varchar",{
    nullable:false,
    length:30,
    name:"device_mac_id"
  })
  deviceMacId:string;

  @Column({
    type: 'enum',
    enum: DeviceStatusEnum,
    nullable: false,
    default: DeviceStatusEnum.ONLINE,
    name: 'device_status'
  })
  deviceStatus: DeviceStatusEnum;

  @Column("text", {
    nullable: true,
    name: "device_error_msg"
  })
  deviceErrorMsg: string;

  @Column({
    name: "last_reported_time",
    type: "datetime",
    nullable: true,
  })
  lastReportedTime: Date;

  @Column('integer', {
    nullable: false,
    name: 'plant_id'
  })
  plantId: number;

  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;

  @Column("varchar",{
    nullable:true,
    length:30,
    name:"dept_name"
  })
  deptName:string;

  @Column("varchar",{
    nullable:true,
    length:10,
    name:"dept_code"
  })
  deptCode:string;

  @Column("varchar",{
    nullable:true,
    length:20,
    name:"module"
  })
  module:string;

  @Column("varchar",{
    nullable:false,
    length:20,
    name:"device_category"
  })
  deviceCategory: DeviceCategoryEnum;

  @Column("varchar",{
    nullable:false,
    length:100,
    name:"secret_key",
    default: ""
  })
  secretKey: string;
  
}
